/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: DeJ932qvZqev

import * as React from "react";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicOrgSwitcherRow.module.css"; // plasmic-import: DeJ932qvZqev/css

import CheckIcon from "../plasmic_kit/PlasmicIcon__Check"; // plasmic-import: pawp1H5YxB_3B/icon

createPlasmicElementProxy;

export type PlasmicOrgSwitcherRow__VariantMembers = {
  selected: "selected";
  status: "paid" | "trial" | "trialEnded";
};
export type PlasmicOrgSwitcherRow__VariantsArgs = {
  selected?: SingleBooleanChoiceArg<"selected">;
  status?: SingleChoiceArg<"paid" | "trial" | "trialEnded">;
};
type VariantPropType = keyof PlasmicOrgSwitcherRow__VariantsArgs;
export const PlasmicOrgSwitcherRow__VariantProps = new Array<VariantPropType>(
  "selected",
  "status"
);

export type PlasmicOrgSwitcherRow__ArgsType = {
  avatarContainer?: React.ReactNode;
  name?: string;
  workspaceCount?: number;
  plan?: string;
};
type ArgPropType = keyof PlasmicOrgSwitcherRow__ArgsType;
export const PlasmicOrgSwitcherRow__ArgProps = new Array<ArgPropType>(
  "avatarContainer",
  "name",
  "workspaceCount",
  "plan"
);

export type PlasmicOrgSwitcherRow__OverridesType = {
  root?: Flex__<"div">;
  svg?: Flex__<"svg">;
};

export interface DefaultOrgSwitcherRowProps {
  avatarContainer?: React.ReactNode;
  name?: string;
  workspaceCount?: number;
  plan?: string;
  selected?: SingleBooleanChoiceArg<"selected">;
  status?: SingleChoiceArg<"paid" | "trial" | "trialEnded">;
  className?: string;
}

const $$ = {};

function PlasmicOrgSwitcherRow__RenderFunc(props: {
  variants: PlasmicOrgSwitcherRow__VariantsArgs;
  args: PlasmicOrgSwitcherRow__ArgsType;
  overrides: PlasmicOrgSwitcherRow__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "selected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.selected
      },
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.status
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const [isRootFocusVisible, triggerRootFocusVisibleProps] = useTrigger(
    "useFocusVisible",
    {
      isTextInput: false
    }
  );
  const triggers = {
    focusVisible_root: isRootFocusVisible
  };

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_ooL7EhXDmFQWnW9sxtchhE",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.root___focusVisible]: triggers.focusVisible_root,
          [sty.rootselected]: hasVariant($state, "selected", "selected"),
          [sty.rootstatus_paid]: hasVariant($state, "status", "paid")
        }
      )}
      tabIndex={0}
      data-plasmic-trigger-props={[triggerRootFocusVisibleProps]}
    >
      <div
        className={classNames("all", sty.freeBox__vhNxb, {
          [sty.freeBox___focusVisible__vhNxbw8Hrx]: triggers.focusVisible_root
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <img
              alt={""}
              className={classNames("all", "img", "img__ooL7E", sty.img__rFck)}
              loading={"lazy"}
            />
          ),

          value: args.avatarContainer
        })}
      </div>
      <div
        className={classNames("all", sty.freeBox__aYjpn, {
          [sty.freeBox___focusVisible__aYjpnW8Hrx]: triggers.focusVisible_root
        })}
      >
        <div
          className={classNames("all", "__wab_text", sty.text__zJucp, {
            [sty.textstatus_trialEnded__zJucpKQ88]: hasVariant(
              $state,
              "status",
              "trialEnded"
            )
          })}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.name;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "Plasmic's First Organization";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
        <div
          className={classNames("all", "__wab_text", sty.text__qD8Wr, {
            [sty.text___focusVisible__qD8Wrw8Hrx]: triggers.focusVisible_root,
            [sty.textselected__qD8WrSyBw]: hasVariant(
              $state,
              "selected",
              "selected"
            ),
            [sty.textstatus_paid__qD8Wr6IMot]: hasVariant(
              $state,
              "status",
              "paid"
            )
          })}
        >
          <React.Fragment>
            <React.Fragment>{""}</React.Fragment>
            {
              <span
                className={classNames(
                  "all",
                  "span",
                  "span__ooL7E",
                  "__wab_text",
                  "plasmic_default__inline",
                  sty.span__bq5Ox,
                  {
                    [sty.spanstatus_trialEnded__bq5OxKQ88]: hasVariant(
                      $state,
                      "status",
                      "trialEnded"
                    ),
                    [sty.spanstatus_trial__bq5Ox6KexC]: hasVariant(
                      $state,
                      "status",
                      "trial"
                    )
                  }
                )}
              >
                <React.Fragment>{`${$props.workspaceCount} workspace${$props.workspaceCount === 1 ? "" : "s"}`}</React.Fragment>
              </span>
            }
            <React.Fragment>{" \u00b7 "}</React.Fragment>
            {
              <span
                className={classNames(
                  "all",
                  "span",
                  "span__ooL7E",
                  "__wab_text",
                  "plasmic_default__inline",
                  sty.span__s5HTq,
                  {
                    [sty.spanstatus_paid__s5HTq6IMot]: hasVariant(
                      $state,
                      "status",
                      "paid"
                    ),
                    [sty.spanstatus_trialEnded__s5HTqKQ88]: hasVariant(
                      $state,
                      "status",
                      "trialEnded"
                    ),
                    [sty.spanstatus_trial__s5HTq6KexC]: hasVariant(
                      $state,
                      "status",
                      "trial"
                    )
                  }
                )}
              >
                {hasVariant($state, "status", "trialEnded") ? (
                  <React.Fragment>{"Trial ended"}</React.Fragment>
                ) : hasVariant($state, "status", "trial") ? (
                  <React.Fragment>{"Free trial"}</React.Fragment>
                ) : (
                  <React.Fragment>{$props.plan}</React.Fragment>
                )}
              </span>
            }
            <React.Fragment>{""}</React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div
        className={classNames("all", sty.freeBox__xyuOq, {
          [sty.freeBox___focusVisible__xyuOqw8Hrx]: triggers.focusVisible_root,
          [sty.freeBoxselected__xyuOqSyBw]: hasVariant(
            $state,
            "selected",
            "selected"
          )
        })}
      >
        {(hasVariant($state, "selected", "selected") ? true : false) ? (
          <CheckIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}

            className={classNames("all", sty.svg, {
              [sty.svgselected]: hasVariant($state, "selected", "selected")
            })}
            role={"img"}
          />
        ) : null}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "svg"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicOrgSwitcherRow__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicOrgSwitcherRow__VariantsArgs;
    args?: PlasmicOrgSwitcherRow__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicOrgSwitcherRow__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicOrgSwitcherRow__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOrgSwitcherRow__ArgProps,
          internalVariantPropNames: PlasmicOrgSwitcherRow__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOrgSwitcherRow__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOrgSwitcherRow";
  } else {
    func.displayName = `PlasmicOrgSwitcherRow.${nodeName}`;
  }
  return func;
}

export const PlasmicOrgSwitcherRow = Object.assign(
  // Top-level PlasmicOrgSwitcherRow renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicOrgSwitcherRow
    internalVariantProps: PlasmicOrgSwitcherRow__VariantProps,
    internalArgProps: PlasmicOrgSwitcherRow__ArgProps
  }
);

export default PlasmicOrgSwitcherRow;
/* prettier-ignore-end */
